export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4 text-teal-400">Dinari Designs</h3>
            <p className="text-gray-400 mb-4 leading-relaxed">
              Professional construction layout and formwork services across British Columbia.
            </p>
            <div className="space-y-2">
              <div className="flex items-center text-gray-400">
                <i className="ri-phone-line mr-2 text-teal-400"></i>
                <span className="whitespace-nowrap">+1-604-123-4567</span>
              </div>
              <div className="flex items-center text-gray-400">
                <i className="ri-mail-line mr-2 text-teal-400"></i>
                <span>dinaridesigns@gmail.com</span>
              </div>
              <div className="flex items-center text-gray-400">
                <i className="ri-map-pin-line mr-2 text-teal-400"></i>
                <span>Vancouver, BC</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-teal-400">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="/#services" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 cursor-pointer whitespace-nowrap">
                  Services
                </a>
              </li>
              <li>
                <a href="/#about" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 cursor-pointer whitespace-nowrap">
                  About
                </a>
              </li>
              <li>
                <a href="/#projects" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 cursor-pointer whitespace-nowrap">
                  Projects
                </a>
              </li>
              <li>
                <a href="/knowledge-hub" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 cursor-pointer whitespace-nowrap">
                  Knowledge Hub
                </a>
              </li>
              <li>
                <a href="/areas-we-serve" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 cursor-pointer whitespace-nowrap">
                  Areas We Serve
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-teal-400">Our Services</h4>
            <ul className="space-y-2">
              <li className="text-gray-400">AutoCAD Layout Design</li>
              <li className="text-gray-400">Formwork Detailing</li>
              <li className="text-gray-400">Bluebeam Takeoffs</li>
              <li className="text-gray-400">Site Planning</li>
              <li className="text-gray-400">Technical Consulting</li>
            </ul>
          </div>

          {/* CTA */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-teal-400">Ready to Scale?</h4>
            <p className="text-gray-400 mb-4 leading-relaxed">
              Expand your project scope without the overhead of full-time hiring.
            </p>
            <a
              href="/#contact"
              className="inline-flex items-center px-6 py-3 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-rocket-line mr-2"></i>
              Scale My Business Today
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2026 Dinari Designs. All rights reserved.
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-teal-400 text-sm transition-colors duration-300 cursor-pointer whitespace-nowrap"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
